module.exports = __webpack_public_path__ + "static/media/chart-line-input.464a0c97.svg";